import { constantRoutes } from "@/router";
import menuRoutes from "@/router/menu";
import fmRoutes from "@/router/fMenu";
import { producerMyInfo, expiredWell } from "@/api/producer.js";
const Year = new Date().getFullYear();
let annualDays = Year % 4 == 0 && Year % 100 != 0 ? 361 : 360; // 366 - 5 ,  365 - 5
const menuMap = {};
const permission = {
  state: {
    role: 0, //1是fm 2 是其他
    routes: [],
    addRoutes: [],
    menus: [],
    annualInfo: {}
  },
  mutations: {
    SET_ROLE: (state, val) => {
      console.log(val);
      state.role = val;
    },
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes;
      state.routes = constantRoutes.concat(routes);
    },
    SET_ANNUALINFO: (state, data) => {
      state.annualInfo = data;
    }
  },
  actions: {
    GenerateRoutes({ commit, state }, role) {
      return new Promise(resolve => {
        console.log(state.role);

        // 临时修改：始终使用role为1的菜单(fm菜单)，忽略实际role
        // TODO: 后续需要恢复下方被注释的代码，删除这段临时代码
        // commit("SET_ROLE", 1); // 强制设置为role为1
        // fmRoutes.push({ path: "*", redirect: "/404", hidden: true });
        // commit("SET_ROUTES", fmRoutes);
        // resolve(fmRoutes);

        // 原始代码，后续恢复时取消注释
        if (state.role === 1) {
          fmRoutes.push({ path: "*", redirect: "/404", hidden: true });
          commit("SET_ROUTES", fmRoutes);
          resolve(fmRoutes);
        } else {
          menuRoutes.push({ path: "*", redirect: "/404", hidden: true });
          commit("SET_ROUTES", menuRoutes);
          resolve(menuRoutes);
        }
      });
    },
    SetRole({ commit, state }, role) {
      return new Promise(resolve => {
        commit("SET_ROLE", role);
        resolve();
      });
    },
    GetRole({ state }) {
      return new Promise(resolve => {
        resolve(state.role);
      });
    }
  }
};

function getProducerMyInfo() {
  return new Promise((resolve, reject) => {
    expiredWell()
      .then(res => {
        let isExpired = false;
        let isReject = false;
        let resData = res.result || {};
        let pointList = resData.list.filter(i => i.mpID);
        let wellList = resData.list.filter(i => !i.mpID);
        let nowTime = new Date().getTime();
        pointList.forEach((i, p_index) => {
          let pointWells = i.wells || [];
          pointWells.forEach((well, well_index) => {
            let wellTime = new Date(well.timestamp).getTime();
            if (well.status == 1) {
              if ((nowTime - wellTime) / 1000 / 3600 / 24 >= annualDays) {
                isExpired = true;
              } else {
                pointList[p_index].wells.splice(well_index, 1);
              }
            }
            if (well.status == 2) {
              isExpired = true;
            }
            if (well.status == 6) {
              isReject = true;
            }
          });
        });

        wellList.forEach((i, well_index) => {
          let wellTime = new Date(i.timestamp).getTime();
          if (i.status == 1) {
            if ((nowTime - wellTime) / 1000 / 3600 / 24 >= annualDays) {
              isExpired = true;
            } else {
              wellList.splice(well_index, 1);
            }
          }
          if (i.status == 2) {
            isExpired = true;
          }
          if (i.status == 6) {
            isReject = true;
          }
        });

        resolve({
          producer: resData.producer,
          pointList,
          wellList,
          isExpired,
          isReject
        });
      })
      .catch(err => {
        reject(err);
      });
  });
}

// Get the map of the menu data returned from the background to facilitate the filtering operation. Note: this method is processed according to the actual item menu data format
function getMneuMap(menu) {
  for (let i = 0; i < menu.length; i++) {
    if (!menu[i].subMenu || (menu[i].subMenu && menu[i].subMenu.length == 0)) {
      if (!menuMap[menu[i].path]) {
        menuMap[menu[i].path] = {
          path: menu[i].path,
          icon: menu[i].icon
        };
      }
    } else {
      getMneuMap(menu[i].subMenu);
    }
  }
}
function filterMenuRoute(menu, role, isAnnualNav) {
  return menu.filter(i => {
    if (!i.children) {
      if (i.roles && i.roles.indexOf(role) > -1) {
        if (
          role == 0 &&
          isAnnualNav &&
          i.path == "/wellManagement/annualReview"
        ) {
          i.hidden = false;
          return i;
        }
        return i;
      }
    } else if (i.children.length) {
      i.children = filterMenuRoute(i.children, role, isAnnualNav);
    }
  });
}

export const loadView = view => {
  // return () => import(`@/views/${view}`);
  return () => Promise.resolve(require(`@/views/${view}`).default);
};

export default permission;
